export default __webpack_public_path__ + "static/media/lc-logo.152279f8.png";